export const IsDevelopment: boolean = process.env.NODE_ENV === "development";

export const IsConfigModeLocalGlobally = process.env.GLOBAL_CONFIG_MODE === "local";

/**
 * Default values for PoliciesDefinition in GlobalConfiguration
 * Status icon:
 *   - showInSearchResults: true
 *   - showInPolicyDetails: true
 * Status name:
 *   - showInPolicyDetails: true
 *   - showInSearchResults: false
 * Coverages
 *   - showExclusionsSection: true
 *   - showCoverageTypeTag: true
 *   - showFlexAmount: true
 *   - showFlexFaceAmount: true
 *   - showBeneficiaryDesignation: true
 */
export const defaultPoliciesDefinition: PoliciesDefinition = {
    statusIcon: {
        showInSearchResults: true,
        showInPolicyDetails: true,
    },
    statusName: {
        showInPolicyDetails: true,
        showInSearchResults: false,
    },
    coverages: {
        showExclusionsSection: true,
        showCoverageTypeTag: true,
        showFlexAmount: true,
        showFlexFaceAmount: true,
        showBeneficiaryDesignation: true,
    },
};

/**
 * Default application insights configuration:
 * azure:
 *  - enabled: false
 */
export const defaultInsightsDefinition: InsightsDefinition = {
    azure: {
        enabled: false,
        instrumentationKey: "",
        connectionString: "",
    },
};

/**
 * Default google tag manager configuration:
 * tagManager: undefined
 * @remarks - undefined means the tag manager will not be started
 */
export const defaultAnalyticsDefinition: AnalyticsDefinition = {};

/**
 * Default timers for user interactions, in seconds:
 * "idleTimer":
 * \{
 *   "default": 3600,
 *   "tablet": 3600,
 *   "mobile": 300
 * \},
 * "countdownTimer": \{
 *   "default": 60,
 *   "tablet": 60,
 *   "mobile": 30
 * \}
 */
export const defaultUserActivityDefinition: UserActivityDefinition = {
    countdownTimer: {
        default: 60,
        mobile: 30,
        tablet: 60,
    },
    idleTimer: {
        default: 3600,
        mobile: 300,
        tablet: 3600,
    },
};

export const defaultFaviconUrl = "favicon.png";
export const defaultLoginPageUrl = "";

export const defaultQuotesConfig: QuotesDefinition = {
    earlyPayOff: {
        showSubmittedQuotes: true,
    },
};
